import dynamic from 'next/dynamic'

export default function TutorProfileLocationWithSSR({tutorProfile}) {
  const Location = dynamic(() => import('./Location'), {
    ssr: false
  })


  return(
    <Location tutorProfile={tutorProfile} />
  )
}
